import React from 'react';
import PropTypes from 'prop-types';
import AppsBanner from '../../components/AppsBanner';
import CategoriesV2 from '../../components/CategoriesV2';
import Categories from '../../components/Categories';
import RecommendedRow from '../../components/RecommendedRow';
import fireBatchedImpressions from '../../lib/BatchImpressions';
import StaffPicks from '../../components/StaffPicks';
import IntentRow from '../../components/IntentRow';
import SurveyButton from '../../components/SurveyButton';
import GetStarted from '../../components/GetStarted';
import QuickLinks from '../../components/QuickLinks';
import CollectionsHero from '../../components/CollectionsHero';

class Main extends React.Component {
  componentDidMount = () => {
    const links = this.getImpressionLinks();
    const {
      toolTileProps: {
        app: { csrf = '' } = {},
        flatPSData: { isNewLayoutEligible } = {}
      } = {}
    } = this.props;
    fireBatchedImpressions(links, csrf);

    const bgColorEl = document
      .getElementById('merchanthub-app-wrapper')
      ?.getElementsByClassName('vx_foreground-container')[0];
    if (isNewLayoutEligible && bgColorEl) {
      bgColorEl.style.background = '#FFF';
    }
  };

  getImpressionLinks = () => {
    const links = [];
    const {
      structuredPSData: {
        content: { PSImpressionUrl = '' },
        categories = []
      } = {}
    } = this.props;
    links.push(PSImpressionUrl);
    categories.forEach(({ content = {}, featured = [] }) => {
      links.push(content.PSImpressionUrl);
      featured.forEach(({ PSImpressionUrl = '' }) => {
        links.push(PSImpressionUrl);
      });
    });
    return links;
  };

  renderYourRecommendations = () => {
    const {
      fptiClick,
      fptiImpression,
      toolTileProps,
      defaultRecommended = []
    } = this.props;
    const {
      flatPSData: { recommended = [], isNewLayoutEligible } = {}
    } = toolTileProps;

    const categoryPageLink = 'home_page_recommendation';

    return (
      <div
        id="appcenter-categories"
        className={isNewLayoutEligible ? 'mobile-bkg' : ''}
      >
        <RecommendedRow
          content={recommended[0]}
          featured={defaultRecommended}
          fptiClick={fptiClick}
          fptiImpression={fptiImpression}
          toolTileProps={toolTileProps}
          categoryPageLink={categoryPageLink}
        />
      </div>
    );
  };

  renderIntentTools = () => {
    const {
      fptiClick,
      experimentation = {},
      fptiImpression,
      toolTileProps,
      structuredPSData = {}
    } = this.props;
    const { flatPSData: { intentRow = [] } = {} } = toolTileProps;
    const { intentToolsDisplayed = [] } = structuredPSData;
    return !intentToolsDisplayed.length || !experimentation.intentExp ? null : (
      <IntentRow
        fptiImpression={fptiImpression}
        fptiClick={fptiClick}
        toolTileProps={toolTileProps}
        content={intentRow[0]}
        structuredPSData={structuredPSData}
        {...this.props}
      />
    );
  };

  renderStaffPicks = () => {
    const {
      fptiClick,
      fptiImpression,
      toolTileProps,
      structuredPSData,
      experimentation = {}
    } = this.props;
    const { flatPSData: { staffPick = [] } = {} } = toolTileProps;
    const { staffPickDisplayed = [] } = structuredPSData;

    if (
      !staffPickDisplayed.length ||
      !experimentation.staffPickExp ||
      !staffPick[0] ||
      !staffPick[0].categoryTitle
    ) {
      return null;
    }

    return (
      <StaffPicks
        fptiImpression={fptiImpression}
        fptiClick={fptiClick}
        content={staffPick[0]}
        toolTileProps={toolTileProps}
        {...this.props}
      />
    );
  };

  renderGetStarted = () => {
    const {
      fptiClick,
      fptiImpression,
      toolTileProps: {
        flatPSData: {
          getStarted = [],
          tools = {},
          categories = {},
          intentMessages = [],
          isNewLayoutEligible
        } = {}
      } = {}
    } = this.props;
    return (
      <GetStarted
        fptiClick={fptiClick}
        fptiImpression={fptiImpression}
        content={getStarted[0]}
        appIntents={intentMessages}
        tools={tools}
        categories={categories}
        isNewLayoutEligible={isNewLayoutEligible}
        toolTileProps={this.props.toolTileProps}
      />
    );
  };

  render() {
    const {
      structuredPSData: { content = {}, categories = [] } = {},
      fptiClick,
      fptiImpression,
      quicklinks,
      toolTileProps: {
        app: {
          context: {
            user: { isLoggedIn } = {},
            location: { cdn: cdnHost = 'www.paypalobjects.com' } = {}
          } = {},
          deviceInfo: { isDesktop } = {}
        } = {},
        flatPSData: {
          isRecommendedCategoryEligible,
          isMerchantActivated,
          isNewLayoutEligible,
          collections,
          collectionIntentBanners
        } = {}
      } = {},
      experimentation: { moduleFederation, getStartedExp } = {}
    } = this.props;

    const shouldShowGetStartedRec = !isMerchantActivated && !!getStartedExp;

    return (
      <div id="appcenter-main">
        {isNewLayoutEligible ? (
          <CollectionsHero
            collections={collections}
            collectionsIntents={collectionIntentBanners}
            collectionsTitle={content.collectionsTitle}
            fptiClick={fptiClick}
            fptiImpression={fptiImpression}
          />
        ) : (
          <AppsBanner content={content} />
        )}
        {isLoggedIn && shouldShowGetStartedRec && this.renderGetStarted()}
        {isLoggedIn &&
          isRecommendedCategoryEligible &&
          this.renderYourRecommendations()}
        {isLoggedIn &&
          !shouldShowGetStartedRec &&
          isNewLayoutEligible &&
          this.renderStaffPicks()}
        {isLoggedIn &&
          !shouldShowGetStartedRec &&
          !isNewLayoutEligible &&
          this.renderStaffPicks()}
        {!isLoggedIn && this.renderIntentTools()}
        {isDesktop && !shouldShowGetStartedRec && !isNewLayoutEligible && (
          <QuickLinks
            moduleFederation={moduleFederation}
            quicklinks={quicklinks}
            isLoggedIn={isLoggedIn}
            isDesktop={isDesktop}
            cdnHost={cdnHost}
          />
        )}
        {isNewLayoutEligible ? (
          <CategoriesV2
            categories={categories}
            viewAllText={content.viewDetails}
            showAllText={content.showDetails}
            fptiClick={fptiClick}
            fptiImpression={fptiImpression}
            toolTileProps={this.props.toolTileProps}
          />
        ) : (
          <Categories
            categories={categories}
            viewAllText={content.viewDetails}
            showAllText={content.showDetails}
            fptiClick={fptiClick}
            fptiImpression={fptiImpression}
            toolTileProps={this.props.toolTileProps}
          />
        )}
        <SurveyButton
          fptiClick={fptiClick}
          toolTileProps={this.props.toolTileProps}
          isNewLayoutEligible={isNewLayoutEligible}
          content={content}
        />
      </div>
    );
  }
}

Main.displayName = 'main';

Main.propTypes = {
  categories: PropTypes.array,
  ps: PropTypes.object,
  dispatch: PropTypes.func,
  appSearch: PropTypes.object,
  clearSearch: PropTypes.func,
  structuredPSData: PropTypes.object,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  toolTileProps: PropTypes.object,
  defaultRecommended: PropTypes.array,
  experimentation: PropTypes.object,
  quicklinks: PropTypes.object
};

export default Main;
